import { render } from "./GeneareteReceiptVoucher.vue?vue&type=template&id=cd947f1e"
import script from "./GeneareteReceiptVoucher.vue?vue&type=script&lang=js"
export * from "./GeneareteReceiptVoucher.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__